<template>
  <div class="setting">
    <section>
      <div class="list-group list-group-flush">
        <button class="list-group-item" @click="generateURL">
          <h6>URLシェア</h6>
          <span class="small">クリックすると、共有・保存用のURLを取得できます</span>
        </button>
      </div>
    </section>
    <b-modal
      id="showurl"
      title="保存・シェア用URL"
      :ok-only="true"
      v-model="modalShow">
      <p class="my-3 text-break">
        {{url}}
      </p>
      <p class="my-3 small">
        このURLを自分のメモ帳に保存してもう一度聞いたり、<br>
        他の人にメールなどで送り、リズムを共有することが出来ます。
      </p>
    </b-modal>
  </div>
</template>

<script>
import {generateURLparam} from '../../url_trans/url_transffer'
export default {
  name: 'setting',
  data: function(){
    return {
      url: '',
      modalShow: false,
    }
  },
  methods: {
    generateURL: function (){
      const rm = generateURLparam(this.$store.state.score);
      const tp = this.$store.state.tempo;
      const params = '?tp=' + tp + '&rm=' + rm;
      this.url = 'https://rhythm-calculator.colour-field.jp/ja/app' + params;
      this.modalShow = true;
    }
  }
}
</script>

<style scoped>
.setting{
  display: block;
  position: relative;
  width: 100%;
  height: 264px;
  margin: 0 auto;
  padding: 8px 0 0;
  text-align: left;
}
.setting section{
  display: block;
  position: relative;
  max-width: 360px;
  margin: 0 auto;
}
.setting section h3{
  font-size: 1rem;
  display: block;
  margin: 0 4px 4px;
}
.setting section > div > button{
  border-radius: 10px;
}
</style>
